export { periodDetailsRoute } from './route'
